/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'H'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAPH000001',
    EAPZ000003: 'EAPH000003',
    EAPZ000004: 'EAPH000004',
    EAPZ000009: 'EAPH000009',
    EAPZ000010: 'EAPH000010',
    EAPZ000018: 'EAPH000018',
    EAPZ000019: 'EAPH000019',
    EAPZ000020: 'EAPH000020',
    EAPZ000050: 'EAPH000050',
    EAPZ000051: 'EAPH000051',
    EBAA000002: 'EBAH100002',
    EBAA000003: 'EBAH100003',
    EBAZ000004: 'EBAH000004',
    EBAZ000005: 'EBAH000005',
    EBAZ000006: 'EBAH000006',
    EBAZ000007: 'EBAH000007',
    EBAZ000008: 'EBAH000008',
    EBAZ000009: 'EBAH000009',
    EBAZ000010: 'EBAH000010',
    EBAZ000011: 'EBAH000011',
    EBAZ000012: 'EBAH000012',
    EBAZ000013: 'EBAH000013',
    EBAZ000015: 'EBAH000015',
    EBAZ000104: 'EBAH000104',
    EBAZ000109: 'EBAH000109',
    EBAZ000111: 'EBAH000111',
    EBAZ000112: 'EBAH000112',
    EBAZ000113: 'EBAH000113',
    EBAZ000114: 'EBAH000114',
    EBAZ000115: 'EBAH000115',
    EBAZ000116: 'EBAH000116',
    EBAZ000117: 'EBAH000117',
    EBAZ000119: 'EBAH000119',
    EBAZ000120: 'EBAH000120',
    EBAZ000121: 'EBAH000121',
    EBAZ000122: 'EBAH000122',
    EBAZ000123: 'EBAH000123',
    EBAZ000124: 'EBAH000124',
    EBAZ000126: 'EBAH000126',
    EBAZ000127: 'EBAH000127',
    EBAZ000128: 'EBAH000128',
    EBAZ000293: 'EBAH000293',
    EBAZ000294: 'EBAH000294',
    EBAZ000319: 'EBAH000319',
    EBAZ000322: 'EBAH000322',
    EBAZ000349: 'EBAH000349',
    EBAZ000350: 'EBAH000350',
    EBAZ000351: 'EBAH000351',
    EBAZ000353: 'EBAH000353',
    EBAZ000355: 'EBAH000355',
    EBAZ000357: 'EBAH000357',
    EBAZ000358: 'EBAH000358',
    EBAZ000359: 'EBAH000359',
    EBAZ000363: 'EBAH000363',
    EBAZ000364: 'EBAH000364',
    EBAZ000379: 'EBAH000379',
    EBAZ000397: 'EBAH000397',
    EBAZ000398: 'EBAH000398',
    EBAZ000399: 'EBAH000399',
    EBAZ000496: 'EBAH000496',
    EBAZ000619: 'EBAH000619',
    EBAZ000644: 'EBAH000644',
    EBAZ000645: 'EBAH000645',
    EBAZ000647: 'EBAH000647',
    EBAZ000656: 'EBAH000656',
    EBAZ000721: 'EBAH000721',
    EBAZ000723: 'EBAH000723',
    EBAZ000731: 'EBAH000731',
    EBAZ000732: 'EBAH000732',
    EBAZ000733: 'EBAH000733',
    EBAZ000734: 'EBAH000734',
    EBAZ000774: 'EBAH000774',
    EBAZ000776: 'EBAH000776',
    EBAZ000781: 'EBAH000781',
    EBAZ000811: 'EBAH000811',
    EBAZ000812: 'EBAH000812',
    EBAZ000814: 'EBAH000814',
    EBAZ000816: 'EBAH000816',
    EBAZ000818: 'EBAH000818',
    EBAZ000819: 'EBAH000819',
    EBAZ000823: 'EBAH000823',
    EBAZ000892: 'EBAH000892',
    EBAZ000909: 'EBAH000909',
    EBAZ000999: 'EBAH000999',
    EIFA000001: 'EIFH100001',
    EIFA000002: 'EIFH100002',
    EIFA000003: 'EIFH100003',
    EIFA000004: 'EIFH100004',
    EIFA000005: 'EIFH100005',
    EIFA000006: 'EIFH100006',
    EIFA000007: 'EIFH100007',
    EIFA000009: 'EIFH100009',
    EIFA000010: 'EIFH100010',
    EIFA000011: 'EIFH100011',
    FDXZ000005: 'FDXH000005',
    FIFA000001: 'FIFH100001',
    FIFA000002: 'FIFH100002',
  },
};

/**
 * ワーニングコードの定数定義
 */
export const WarningCodeConstants = {
  // ワーニングコード一覧(4桁目'H'とする)
  WARNING_CODES: {
    WBAZ000046: 'WBAH000046',
    WBAZ000047: 'WBAH000047',
    WBAZ000247: 'WBAH000247',
    WBAZ000252: 'WBAH000252',
    WBAZ000255: 'WBAH000255',
    WBAZ000570: 'WBAH000570',
    WBAZ000578: 'WBAH000578',
    WBAZ000579: 'WBAH000579',
    WBAZ000580: 'WBAH000580',
    WBAZ000581: 'WBAH000581',
    WBAZ000582: 'WBAH000582',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'ADO',
  TWO_LETTER: 'HD',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'SPKHD08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'SPKHD08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'SPKHD08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: 'alphaNumberic' as 'alphaNumberic' | 'numberic',
    length: 10,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 8,
    maxPwLength: 20,
    pwRegex: '^[a-zA-Z0-9-_.+$#!/@(%&*?)]*$',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: true,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: true,
  LOGO_FILE_PATH: 'assets/images/logo_ado.svg',
  LOGO_S_FILE_PATH: 'assets/images/logo_ado_s.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_ado_biz.png',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {
    [ErrorCodeConstants.ERROR_CODES.EIFA000001]: 'EA021', // ログイン情報なし
    [ErrorCodeConstants.ERROR_CODES.EIFA000002]: 'EA022', // ログイン情報が無効
    [ErrorCodeConstants.ERROR_CODES.EIFA000003]: 'EA014', // 一定時間内のログイン試行回数超過によりブロックされた会員
    [ErrorCodeConstants.ERROR_CODES.EIFA000004]: 'EA020', // パスワード不一致
    [ErrorCodeConstants.ERROR_CODES.EIFA000005]: 'EA013', // パスワード有効期限切れ
    [ErrorCodeConstants.ERROR_CODES.EIFA000006]: 'EA016',
    [ErrorCodeConstants.ERROR_CODES.EIFA000007]: 'EA023',
    [ErrorCodeConstants.ERROR_CODES.EIFA000009]: 'EA017',
    [ErrorCodeConstants.ERROR_CODES.EIFA000010]: 'EA026',
    [ErrorCodeConstants.ERROR_CODES.EIFA000011]: 'EA015',
    [ErrorCodeConstants.ERROR_CODES.EBAA000002]: 'EA050', // 会員区分が無効会員の場合
    [ErrorCodeConstants.ERROR_CODES.EBAA000003]: 'EA051', // 認証結果がfalse
    [ErrorCodeConstants.ERROR_CODES.EAPZ000009]: 'E0361', // 搭乗者に含まれているかチェック
    [ErrorCodeConstants.ERROR_CODES.EAPZ000010]: 'E0361', // マイル減算者の会員かチェックエラー
    [ErrorCodeConstants.ERROR_CODES.FIFA000001]: 'EA015', // ifly接続エラー(想定外エラー)
    [ErrorCodeConstants.ERROR_CODES.FIFA000002]: 'EA019', // iflyエラー
  } as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    AUTH_LOGIN: {
      ENDPOINT: /\/all-.*-member\/api\/.*\/auth-login/,
      METHOD: 'POST',
    },
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  IMG: {
    // 全体
    ALL_EXTERNAL_PRIMARY: 'assets/images/icon_external_ado_blue_16.svg',
    ALL_EXTERNAL_RED: 'assets/images/icon_external_ado_red_16.svg',
    ALL_HELP_PRIMARY: 'assets/images/icon_help_ado_blue_24.svg',
    ALL_CHECKINSTATUS_NOTACCEPTED: 'assets/images/icon_remove_ado_blue_20.svg',
    ALL_CHECKINSTATUS_ACCEPTED: 'assets/images/icon_feature_available_ado_blue_24.svg',

    // C01-P040-S01-U チェックインシートマップ
    C01_P040_S01_U_SEATMAP_FLOAT_LEGEND: 'assets/images/seatmap_float_legend_ado.svg',
    C01_P040_S01_U_SEATMAP_FLOAT_SEATTYPE: 'assets/images/seatmap_float_seattype_ado.svg',
    C01_P040_S01_U_LEGENDS_SEAT_SELECTED: 'assets/images/seat_selected_ado_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_BEFORE_CHANGE_FREE_SEAT: 'assets/images/seat_before_change_free_seat_ado_24.svg',
    C01_P040_S01_U_LEGENDS_EMERGENCY_EXIT_SEAT: 'assets/images/seat_emergency_exit_seat_ado_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_LAVATORY: 'assets/images/seat_lavatory_ado_24.svg',
    C01_P040_S01_U_LEGENDS_GALLEY: 'assets/images/seat_galley_ado_24.svg',
    C01_P040_S01_U_LEGENDS_WING: 'assets/images/seat_wing_ado_24.svg',
  },
  ABLE_D_TRANSITION_PARAMETER: {
    EXTERNAL_FLG: 'NEWADO',
    ALLIANCE_FLG: 'ADO',
  },
} as const;
